module.exports = __webpack_public_path__ + "img/link.1bcd0bf4.svg";